import {AxiosPromise} from 'axios';
import httpClient from 'api/httpClient';

export interface GeneratePredictiveInsightsResponse {
    success: boolean;
}

export const generatePredictiveInsightsForBusiness = (
    businessId: number,
): AxiosPromise<GeneratePredictiveInsightsResponse> => {
    return httpClient({
        method: 'GET',
        url: `common/recommendations/assistant/business/${businessId}`,
    });
};
